import { useSelector, RootState } from 'src/state/redux';
import { ContentPreviewModalSliceType } from 'src/state/redux/slice/contentPreviewModal';

export const useContentPreviewModalManagement = (): ContentPreviewModalSliceType =>
  useSelector((state: RootState) => state.contentPreviewModal)
